import { render, staticRenderFns } from "./create_single.vue?vue&type=template&id=de452ae2&scoped=true&"
import script from "./create_single.vue?vue&type=script&lang=ts&"
export * from "./create_single.vue?vue&type=script&lang=ts&"
import style0 from "./create_single.vue?vue&type=style&index=0&id=de452ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de452ae2",
  null
  
)

export default component.exports